/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../common/time';
import './report';
import '../../google/protobuf/field_mask';
import '../connect/v2/common/measurement_units';
import '../common/currency';
import '../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "salesreporter": {
        "nested": {
          "service": {
            "nested": {
              "ItemizationReportRequest": {
                "fields": {
                  "merchantToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "locationIds": {
                    "type": "string",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "reportingPeriod": {
                    "type": ".squareup.common.time.DateTimeInterval",
                    "id": 3,
                    "rule": "optional"
                  },
                  "localReportingHours": {
                    "type": ".squareup.salesreporter.service.LocalTimeInterval",
                    "id": 4,
                    "rule": "optional"
                  },
                  "timeZone": {
                    "type": ".squareup.salesreporter.service.TimeZone",
                    "id": 5,
                    "rule": "optional"
                  },
                  "weeklyStartDay": {
                    "type": ".squareup.common.time.DayOfWeek",
                    "id": 6,
                    "rule": "optional"
                  },
                  "timelinePeriod": {
                    "type": ".squareup.salesreporter.service.TimelinePeriod",
                    "id": 7,
                    "rule": "optional"
                  },
                  "groupByTypes": {
                    "type": ".squareup.salesreporter.service.OrderGroupings",
                    "id": 8,
                    "rule": "optional"
                  },
                  "filters": {
                    "type": ".squareup.salesreporter.service.ItemizationFilterByValue",
                    "id": 9,
                    "rule": "repeated"
                  },
                  "readMask": {
                    "type": ".google.protobuf.FieldMask",
                    "id": 10,
                    "rule": "optional"
                  },
                  "sqlDataSource": {
                    "type": ".squareup.salesreporter.service.SQLDataSource",
                    "id": 11,
                    "rule": "optional"
                  },
                  "internalOptions": {
                    "type": ".squareup.salesreporter.service.ItemizationSalesInternalOptions",
                    "id": 12,
                    "rule": "optional"
                  }
                }
              },
              "SQLDataSource": {
                "values": {
                  "SQL_DATA_SOURCE_DO_NOT_USE": 0,
                  "DATABRICKS": 1,
                  "CLICKHOUSE": 2
                }
              },
              "OrderGroupings": {
                "fields": {
                  "groupings": {
                    "type": ".squareup.salesreporter.service.GroupByType",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "item": {
                    "type": ".squareup.salesreporter.service.ItemGroupings",
                    "id": 2
                  }
                },
                "nested": {
                  "sub_grouping": {
                    "oneof": ["item"]
                  }
                }
              },
              "ItemGroupings": {
                "fields": {
                  "groupings": {
                    "type": ".squareup.salesreporter.service.ItemGroupByType",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "modifier": {
                    "type": ".squareup.salesreporter.service.ModifierGroupings",
                    "id": 2
                  },
                  "discount": {
                    "type": ".squareup.salesreporter.service.DiscountGroupings",
                    "id": 3
                  }
                },
                "nested": {
                  "sub_grouping": {
                    "oneof": ["modifier", "discount"]
                  }
                }
              },
              "ModifierGroupings": {
                "fields": {
                  "groupings": {
                    "type": ".squareup.salesreporter.service.ModifierGroupByType",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "DiscountGroupings": {
                "fields": {
                  "groupings": {
                    "type": ".squareup.salesreporter.service.DiscountGroupByType",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "ItemGroupByType": {
                "values": {
                  "ITEM_GROUP_BY_TYPE_DO_NOT_USE": 0,
                  "ITEM_VARIATION": 1,
                  "ITEM_TYPE": 2,
                  "ITEM_NAME": 3,
                  "ITEM_UNIQUE_MODIFIER_COMBINATION": 4,
                  "ITEM_COMBO_NAME": 5,
                  "ITEM_SKU": 6,
                  "ITEM_REPORTING_CATEGORY": 7,
                  "ITEM_MEASUREMENT_UNIT": 8,
                  "ITEM_MENU_NAME": 9,
                  "ITEM_VARIATION_TOKEN": 10,
                  "ITEM_NOTE": 11,
                  "ITEM_DINING_OPTION_NAME": 12
                }
              },
              "ModifierGroupByType": {
                "values": {
                  "MODIFIER_GROUP_BY_TYPE_DO_NOT_USE": 0,
                  "MODIFIER_LIST_NAME": 1,
                  "MODIFIER_NAME": 2,
                  "MODIFIER_UNIT_PRICE": 3
                }
              },
              "DiscountGroupByType": {
                "values": {
                  "DISCOUNT_GROUP_BY_TYPE_DO_NOT_USE": 0,
                  "DISCOUNT_NAME": 1,
                  "DISCOUNT_COMP_REASON": 2
                }
              },
              "ItemizationFilterByValue": {
                "fields": {
                  "order": {
                    "type": ".squareup.salesreporter.service.FilterByValue",
                    "id": 1
                  },
                  "item": {
                    "type": ".squareup.salesreporter.service.ItemFilterByValue",
                    "id": 2
                  },
                  "modifier": {
                    "type": ".squareup.salesreporter.service.ModifierFilterByValue",
                    "id": 3
                  },
                  "discount": {
                    "type": ".squareup.salesreporter.service.DiscountFilterByValue",
                    "id": 4
                  }
                },
                "nested": {
                  "details": {
                    "oneof": ["order", "item", "modifier", "discount"]
                  }
                }
              },
              "BoolList": {
                "fields": {
                  "value": {
                    "type": "bool",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "ItemFilterByValue": {
                "fields": {
                  "items": {
                    "type": ".squareup.salesreporter.service.ItemList",
                    "id": 1
                  },
                  "skus": {
                    "type": ".squareup.salesreporter.service.SkuList",
                    "id": 2
                  },
                  "reportingCategoryNames": {
                    "type": ".squareup.salesreporter.service.ReportingCategoryNameList",
                    "id": 3
                  },
                  "itemVariationNames": {
                    "type": ".squareup.salesreporter.service.ItemVariationNameList",
                    "id": 4
                  },
                  "menuNames": {
                    "type": ".squareup.salesreporter.service.MenuNameList",
                    "id": 5
                  },
                  "measurementUnits": {
                    "type": ".squareup.salesreporter.service.MeasurementUnitList",
                    "id": 6
                  },
                  "comboNames": {
                    "type": ".squareup.salesreporter.service.ComboNameList",
                    "id": 7
                  }
                },
                "nested": {
                  "filter_value": {
                    "oneof": ["items", "skus", "reportingCategoryNames", "itemVariationNames", "menuNames", "measurementUnits", "comboNames"]
                  }
                }
              },
              "ItemList": {
                "fields": {
                  "item": {
                    "type": ".squareup.salesreporter.service.NameOrTranslationType",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "SkuList": {
                "fields": {
                  "sku": {
                    "type": "string",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "ItemVariationNameList": {
                "fields": {
                  "itemVariationName": {
                    "type": "string",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "ReportingCategoryNameList": {
                "fields": {
                  "reportingCategoryName": {
                    "type": "string",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "MenuNameList": {
                "fields": {
                  "menuName": {
                    "type": "string",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "MeasurementUnitList": {
                "fields": {
                  "measurementUnit": {
                    "type": ".squareup.connect.v2.common.MeasurementUnit",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "ComboNameList": {
                "fields": {
                  "comboName": {
                    "type": "string",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "ModifierFilterByValue": {
                "fields": {
                  "modifierName": {
                    "type": ".squareup.salesreporter.service.ModifierNameList",
                    "id": 1
                  },
                  "modifierListName": {
                    "type": ".squareup.salesreporter.service.StringList",
                    "id": 2
                  }
                },
                "nested": {
                  "filter_value": {
                    "oneof": ["modifierName", "modifierListName"]
                  }
                }
              },
              "ModifierNameList": {
                "fields": {
                  "modifierName": {
                    "type": "string",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "DiscountFilterByValue": {
                "fields": {
                  "discountName": {
                    "type": ".squareup.salesreporter.service.DiscountNameList",
                    "id": 1
                  },
                  "isComp": {
                    "type": ".squareup.salesreporter.service.BoolList",
                    "id": 2
                  },
                  "compReason": {
                    "type": ".squareup.salesreporter.service.StringList",
                    "id": 3
                  }
                },
                "nested": {
                  "filter_value": {
                    "oneof": ["discountName", "isComp", "compReason"]
                  }
                }
              },
              "DiscountNameList": {
                "fields": {
                  "discountName": {
                    "type": "string",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "StringList": {
                "fields": {
                  "value": {
                    "type": "string",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "ItemizationReportResponse": {
                "fields": {
                  "reportData": {
                    "type": ".squareup.salesreporter.service.ItemizationReportData",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "pageInfo": {
                    "type": ".squareup.salesreporter.service.PageInfo",
                    "id": 2,
                    "rule": "optional"
                  },
                  "internalResponseOptions": {
                    "type": ".squareup.salesreporter.service.InternalResponseOptions",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "ItemizationReportData": {
                "fields": {
                  "item": {
                    "type": ".squareup.salesreporter.service.ItemMetrics",
                    "id": 1,
                    "rule": "optional"
                  },
                  "modifier": {
                    "type": ".squareup.salesreporter.service.ModifierMetrics",
                    "id": 2,
                    "rule": "optional"
                  },
                  "discount": {
                    "type": ".squareup.salesreporter.service.DiscountMetrics",
                    "id": 3,
                    "rule": "optional"
                  },
                  "order": {
                    "type": ".squareup.salesreporter.service.OrderMetrics",
                    "id": 6,
                    "rule": "optional"
                  },
                  "reportDataPeriod": {
                    "type": ".squareup.common.time.DateTimeInterval",
                    "id": 4,
                    "rule": "optional"
                  },
                  "groupByValue": {
                    "type": ".squareup.salesreporter.service.ItemizationGroupByValues",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "ItemizationGroupByValues": {
                "fields": {
                  "order": {
                    "type": ".squareup.salesreporter.service.GroupByValue",
                    "id": 1,
                    "rule": "optional"
                  },
                  "item": {
                    "type": ".squareup.salesreporter.service.ItemGroupByValues",
                    "id": 2,
                    "rule": "optional"
                  },
                  "modifier": {
                    "type": ".squareup.salesreporter.service.ModifierGroupByValues",
                    "id": 3,
                    "rule": "optional"
                  },
                  "discount": {
                    "type": ".squareup.salesreporter.service.DiscountGroupByValues",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "ItemGroupByValues": {
                "fields": {
                  "name": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "variationName": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "gtin": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "uniqueModifierCombination": {
                    "type": "double",
                    "id": 4,
                    "keyType": "string"
                  },
                  "comboName": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "sku": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "reportingCategory": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "measurementUnit": {
                    "type": ".squareup.connect.v2.common.MeasurementUnit",
                    "id": 8,
                    "rule": "optional"
                  },
                  "menuName": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "itemVariationToken": {
                    "type": "string",
                    "id": 10,
                    "rule": "optional"
                  },
                  "itemNote": {
                    "type": "string",
                    "id": 11,
                    "rule": "optional"
                  },
                  "diningOptionName": {
                    "type": "string",
                    "id": 12,
                    "rule": "optional"
                  }
                }
              },
              "ModifierGroupByValues": {
                "fields": {
                  "name": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "modifierListName": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "unitPriceMoney": {
                    "type": ".squareup.common.Money",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "DiscountGroupByValues": {
                "fields": {
                  "name": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "compReason": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "Decimal": {
                "fields": {
                  "pleaseDoNotUse": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "ItemMetrics": {
                "fields": {
                  "grossSalesMoney": {
                    "type": ".squareup.common.Money",
                    "id": 1,
                    "rule": "optional"
                  },
                  "grossSalesReturnMoney": {
                    "type": ".squareup.common.Money",
                    "id": 2,
                    "rule": "optional"
                  },
                  "netSalesMoney": {
                    "type": ".squareup.common.Money",
                    "id": 3,
                    "rule": "optional"
                  },
                  "salesTaxMoney": {
                    "type": ".squareup.common.Money",
                    "id": 4,
                    "rule": "optional"
                  },
                  "itemsSold": {
                    "type": "int64",
                    "id": 5,
                    "rule": "optional"
                  },
                  "quantitySold": {
                    "type": ".squareup.salesreporter.service.Decimal",
                    "id": 6,
                    "rule": "optional"
                  },
                  "itemsReturned": {
                    "type": "int64",
                    "id": 7,
                    "rule": "optional"
                  },
                  "quantityReturned": {
                    "type": ".squareup.salesreporter.service.Decimal",
                    "id": 8,
                    "rule": "optional"
                  },
                  "discountMoney": {
                    "type": ".squareup.common.Money",
                    "id": 9,
                    "rule": "optional"
                  },
                  "compsMoney": {
                    "type": ".squareup.common.Money",
                    "id": 10,
                    "rule": "optional"
                  },
                  "netSalesWithTaxMoney": {
                    "type": ".squareup.common.Money",
                    "id": 11,
                    "rule": "optional"
                  },
                  "comboSold": {
                    "type": "int64",
                    "id": 12,
                    "rule": "optional"
                  }
                }
              },
              "ModifierMetrics": {
                "fields": {
                  "grossSalesMoney": {
                    "type": ".squareup.common.Money",
                    "id": 1,
                    "rule": "optional"
                  },
                  "grossSalesReturnMoney": {
                    "type": ".squareup.common.Money",
                    "id": 2,
                    "rule": "optional"
                  },
                  "netSalesMoney": {
                    "type": ".squareup.common.Money",
                    "id": 3,
                    "rule": "optional"
                  },
                  "salesTaxMoney": {
                    "type": ".squareup.common.Money",
                    "id": 4,
                    "rule": "optional"
                  },
                  "quantitySold": {
                    "type": ".squareup.salesreporter.service.Decimal",
                    "id": 5,
                    "rule": "optional"
                  },
                  "quantityReturned": {
                    "type": ".squareup.salesreporter.service.Decimal",
                    "id": 6,
                    "rule": "optional"
                  },
                  "netQuantity": {
                    "type": ".squareup.salesreporter.service.Decimal",
                    "id": 7,
                    "rule": "optional"
                  }
                }
              },
              "DiscountMetrics": {
                "fields": {
                  "amountAppliedMoney": {
                    "type": ".squareup.common.Money",
                    "id": 1,
                    "rule": "optional"
                  },
                  "giftCardAppliedMoney": {
                    "type": ".squareup.common.Money",
                    "id": 2,
                    "rule": "optional"
                  },
                  "discountsAppliedCount": {
                    "type": "int64",
                    "id": 3,
                    "rule": "optional"
                  },
                  "ordersDiscountedCount": {
                    "type": "int64",
                    "id": 4,
                    "rule": "optional"
                  },
                  "itemsDiscountedCount": {
                    "type": "int64",
                    "id": 5,
                    "rule": "optional"
                  },
                  "giftCardsAppliedCount": {
                    "type": "int64",
                    "id": 6,
                    "rule": "optional"
                  }
                }
              },
              "OrderMetrics": {
                "fields": {
                  "transactionDate": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 1,
                    "rule": "optional"
                  },
                  "tenderDetails": {
                    "type": ".squareup.salesreporter.service.TenderDetails",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "latestUpdatedAt": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "TenderDetails": {
                "fields": {
                  "panSuffix": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "cardBrand": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "paymentToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "ItemizationSalesAvailableFiltersRequest": {
                "fields": {
                  "merchantToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "locationIds": {
                    "type": "string",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "reportingPeriod": {
                    "type": ".squareup.common.time.DateTimeInterval",
                    "id": 3,
                    "rule": "optional"
                  },
                  "localReportingHours": {
                    "type": ".squareup.salesreporter.service.LocalTimeInterval",
                    "id": 4,
                    "rule": "optional"
                  },
                  "timeZone": {
                    "type": ".squareup.salesreporter.service.TimeZone",
                    "id": 5,
                    "rule": "optional"
                  },
                  "requestedFilters": {
                    "type": ".squareup.salesreporter.service.ItemizationFilterByValue",
                    "id": 6,
                    "rule": "repeated"
                  },
                  "appliedFilters": {
                    "type": ".squareup.salesreporter.service.ItemizationFilterByValue",
                    "id": 7,
                    "rule": "repeated"
                  },
                  "dataSource": {
                    "type": ".squareup.salesreporter.service.DataSource",
                    "id": 8,
                    "rule": "optional"
                  },
                  "sqlDataSource": {
                    "type": ".squareup.salesreporter.service.SQLDataSource",
                    "id": 9,
                    "rule": "optional"
                  },
                  "internalOptions": {
                    "type": ".squareup.salesreporter.service.ItemizationSalesInternalOptions",
                    "id": 10,
                    "rule": "optional"
                  }
                }
              },
              "ItemizationSalesAvailableFiltersResponse": {
                "fields": {
                  "availableFilters": {
                    "type": ".squareup.salesreporter.service.ItemizationFilterByValue",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "ItemizationSalesInternalOptions": {
                "fields": {
                  "disableAggregationAcrossMultipleMetricsType": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "unsupportedElementBehavior": {
                    "type": ".squareup.salesreporter.service.ItemizationSalesInternalOptions.UnsupportedElementBehavior",
                    "id": 2,
                    "rule": "optional"
                  },
                  "disableCreatedAtOptimization": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "UnsupportedElementBehavior": {
                    "values": {
                      "ERROR": 0,
                      "IGNORE": 1
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.ItemizationReportRequest && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.SQLDataSource && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.OrderGroupings && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.ItemGroupings && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.ModifierGroupings && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.DiscountGroupings && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.ItemGroupByType && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.ModifierGroupByType && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.DiscountGroupByType && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.ItemizationFilterByValue && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.BoolList && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.ItemFilterByValue && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.ItemList && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.SkuList && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.ItemVariationNameList && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.ReportingCategoryNameList && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.MenuNameList && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.MeasurementUnitList && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.ComboNameList && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.ModifierFilterByValue && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.ModifierNameList && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.DiscountFilterByValue && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.DiscountNameList && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.StringList && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.ItemizationReportResponse && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.ItemizationReportData && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.ItemizationGroupByValues && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.ItemGroupByValues && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.ModifierGroupByValues && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.DiscountGroupByValues && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.Decimal && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.ItemMetrics && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.ModifierMetrics && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.DiscountMetrics && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.OrderMetrics && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.TenderDetails && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.ItemizationSalesAvailableFiltersRequest && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.ItemizationSalesAvailableFiltersResponse && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.ItemizationSalesInternalOptions && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.ItemizationSalesInternalOptions?.nested?.UnsupportedElementBehavior) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE ItemizationReportRequest @ squareup/salesreporter/itemization_report.proto at 17:1
 */
export const ItemizationReportRequest = $root.lookupType('squareup.salesreporter.service.ItemizationReportRequest');
fixType(ItemizationReportRequest, {
  merchantToken: {
    notEmpty: true
  },
  reportingPeriod: {
    required: true
  }
});
Builder.createAndAttachToType(ItemizationReportRequest);
/**
 * SOURCE SQLDataSource @ squareup/salesreporter/itemization_report.proto at 37:1
 */
export const SQLDataSource = $root.lookupEnum('squareup.salesreporter.service.SQLDataSource').values;
/**
 * SOURCE OrderGroupings @ squareup/salesreporter/itemization_report.proto at 43:1
 */
export const OrderGroupings = $root.lookupType('squareup.salesreporter.service.OrderGroupings');
fixType(OrderGroupings);
Builder.createAndAttachToType(OrderGroupings);
/**
 * SOURCE ItemGroupings @ squareup/salesreporter/itemization_report.proto at 50:1
 */
export const ItemGroupings = $root.lookupType('squareup.salesreporter.service.ItemGroupings');
fixType(ItemGroupings);
Builder.createAndAttachToType(ItemGroupings);
/**
 * SOURCE ModifierGroupings @ squareup/salesreporter/itemization_report.proto at 58:1
 */
export const ModifierGroupings = $root.lookupType('squareup.salesreporter.service.ModifierGroupings');
fixType(ModifierGroupings);
Builder.createAndAttachToType(ModifierGroupings);
/**
 * SOURCE DiscountGroupings @ squareup/salesreporter/itemization_report.proto at 62:1
 */
export const DiscountGroupings = $root.lookupType('squareup.salesreporter.service.DiscountGroupings');
fixType(DiscountGroupings);
Builder.createAndAttachToType(DiscountGroupings);
/**
 * SOURCE ItemGroupByType @ squareup/salesreporter/itemization_report.proto at 66:1
 */
export const ItemGroupByType = $root.lookupEnum('squareup.salesreporter.service.ItemGroupByType').values;
/**
 * SOURCE ModifierGroupByType @ squareup/salesreporter/itemization_report.proto at 82:1
 */
export const ModifierGroupByType = $root.lookupEnum('squareup.salesreporter.service.ModifierGroupByType').values;
/**
 * SOURCE DiscountGroupByType @ squareup/salesreporter/itemization_report.proto at 89:1
 */
export const DiscountGroupByType = $root.lookupEnum('squareup.salesreporter.service.DiscountGroupByType').values;
/**
 * SOURCE ItemizationFilterByValue @ squareup/salesreporter/itemization_report.proto at 95:1
 */
export const ItemizationFilterByValue = $root.lookupType('squareup.salesreporter.service.ItemizationFilterByValue');
fixType(ItemizationFilterByValue);
Builder.createAndAttachToType(ItemizationFilterByValue);
/**
 * SOURCE BoolList @ squareup/salesreporter/itemization_report.proto at 107:1
 */
export const BoolList = $root.lookupType('squareup.salesreporter.service.BoolList');
fixType(BoolList);
Builder.createAndAttachToType(BoolList);
/**
 * SOURCE ItemFilterByValue @ squareup/salesreporter/itemization_report.proto at 111:1
 */
export const ItemFilterByValue = $root.lookupType('squareup.salesreporter.service.ItemFilterByValue');
fixType(ItemFilterByValue);
Builder.createAndAttachToType(ItemFilterByValue);
/**
 * SOURCE ItemList @ squareup/salesreporter/itemization_report.proto at 123:1
 */
export const ItemList = $root.lookupType('squareup.salesreporter.service.ItemList');
fixType(ItemList);
Builder.createAndAttachToType(ItemList);
/**
 * SOURCE SkuList @ squareup/salesreporter/itemization_report.proto at 127:1
 */
export const SkuList = $root.lookupType('squareup.salesreporter.service.SkuList');
fixType(SkuList);
Builder.createAndAttachToType(SkuList);
/**
 * SOURCE ItemVariationNameList @ squareup/salesreporter/itemization_report.proto at 131:1
 */
export const ItemVariationNameList = $root.lookupType('squareup.salesreporter.service.ItemVariationNameList');
fixType(ItemVariationNameList);
Builder.createAndAttachToType(ItemVariationNameList);
/**
 * SOURCE ReportingCategoryNameList @ squareup/salesreporter/itemization_report.proto at 135:1
 */
export const ReportingCategoryNameList = $root.lookupType('squareup.salesreporter.service.ReportingCategoryNameList');
fixType(ReportingCategoryNameList);
Builder.createAndAttachToType(ReportingCategoryNameList);
/**
 * SOURCE MenuNameList @ squareup/salesreporter/itemization_report.proto at 139:1
 */
export const MenuNameList = $root.lookupType('squareup.salesreporter.service.MenuNameList');
fixType(MenuNameList);
Builder.createAndAttachToType(MenuNameList);
/**
 * SOURCE MeasurementUnitList @ squareup/salesreporter/itemization_report.proto at 143:1
 */
export const MeasurementUnitList = $root.lookupType('squareup.salesreporter.service.MeasurementUnitList');
fixType(MeasurementUnitList);
Builder.createAndAttachToType(MeasurementUnitList);
/**
 * SOURCE ComboNameList @ squareup/salesreporter/itemization_report.proto at 147:1
 */
export const ComboNameList = $root.lookupType('squareup.salesreporter.service.ComboNameList');
fixType(ComboNameList);
Builder.createAndAttachToType(ComboNameList);
/**
 * SOURCE ModifierFilterByValue @ squareup/salesreporter/itemization_report.proto at 151:1
 */
export const ModifierFilterByValue = $root.lookupType('squareup.salesreporter.service.ModifierFilterByValue');
fixType(ModifierFilterByValue);
Builder.createAndAttachToType(ModifierFilterByValue);
/**
 * SOURCE ModifierNameList @ squareup/salesreporter/itemization_report.proto at 158:1
 */
export const ModifierNameList = $root.lookupType('squareup.salesreporter.service.ModifierNameList');
fixType(ModifierNameList);
Builder.createAndAttachToType(ModifierNameList);
/**
 * SOURCE DiscountFilterByValue @ squareup/salesreporter/itemization_report.proto at 162:1
 */
export const DiscountFilterByValue = $root.lookupType('squareup.salesreporter.service.DiscountFilterByValue');
fixType(DiscountFilterByValue);
Builder.createAndAttachToType(DiscountFilterByValue);
/**
 * SOURCE DiscountNameList @ squareup/salesreporter/itemization_report.proto at 170:1
 */
export const DiscountNameList = $root.lookupType('squareup.salesreporter.service.DiscountNameList');
fixType(DiscountNameList);
Builder.createAndAttachToType(DiscountNameList);
/**
 * SOURCE StringList @ squareup/salesreporter/itemization_report.proto at 174:1
 */
export const StringList = $root.lookupType('squareup.salesreporter.service.StringList');
fixType(StringList);
Builder.createAndAttachToType(StringList);
/**
 * SOURCE ItemizationReportResponse @ squareup/salesreporter/itemization_report.proto at 178:1
 */
export const ItemizationReportResponse = $root.lookupType('squareup.salesreporter.service.ItemizationReportResponse');
fixType(ItemizationReportResponse);
Builder.createAndAttachToType(ItemizationReportResponse);
/**
 * SOURCE ItemizationReportData @ squareup/salesreporter/itemization_report.proto at 185:1
 */
export const ItemizationReportData = $root.lookupType('squareup.salesreporter.service.ItemizationReportData');
fixType(ItemizationReportData);
Builder.createAndAttachToType(ItemizationReportData);
/**
 * SOURCE ItemizationGroupByValues @ squareup/salesreporter/itemization_report.proto at 202:1
 */
export const ItemizationGroupByValues = $root.lookupType('squareup.salesreporter.service.ItemizationGroupByValues');
fixType(ItemizationGroupByValues);
Builder.createAndAttachToType(ItemizationGroupByValues);
/**
 * SOURCE ItemGroupByValues @ squareup/salesreporter/itemization_report.proto at 210:1
 */
export const ItemGroupByValues = $root.lookupType('squareup.salesreporter.service.ItemGroupByValues');
fixType(ItemGroupByValues);
Builder.createAndAttachToType(ItemGroupByValues);
/**
 * SOURCE ModifierGroupByValues @ squareup/salesreporter/itemization_report.proto at 226:1
 */
export const ModifierGroupByValues = $root.lookupType('squareup.salesreporter.service.ModifierGroupByValues');
fixType(ModifierGroupByValues);
Builder.createAndAttachToType(ModifierGroupByValues);
/**
 * SOURCE DiscountGroupByValues @ squareup/salesreporter/itemization_report.proto at 232:1
 */
export const DiscountGroupByValues = $root.lookupType('squareup.salesreporter.service.DiscountGroupByValues');
fixType(DiscountGroupByValues);
Builder.createAndAttachToType(DiscountGroupByValues);
/**
 * SOURCE Decimal @ squareup/salesreporter/itemization_report.proto at 237:1
 */
export const Decimal = $root.lookupType('squareup.salesreporter.service.Decimal');
fixType(Decimal);
Builder.createAndAttachToType(Decimal);
/**
 * SOURCE ItemMetrics @ squareup/salesreporter/itemization_report.proto at 293:1
 */
export const ItemMetrics = $root.lookupType('squareup.salesreporter.service.ItemMetrics');
fixType(ItemMetrics);
Builder.createAndAttachToType(ItemMetrics);
/**
 * SOURCE ModifierMetrics @ squareup/salesreporter/itemization_report.proto at 311:1
 */
export const ModifierMetrics = $root.lookupType('squareup.salesreporter.service.ModifierMetrics');
fixType(ModifierMetrics);
Builder.createAndAttachToType(ModifierMetrics);
/**
 * SOURCE DiscountMetrics @ squareup/salesreporter/itemization_report.proto at 321:1
 */
export const DiscountMetrics = $root.lookupType('squareup.salesreporter.service.DiscountMetrics');
fixType(DiscountMetrics);
Builder.createAndAttachToType(DiscountMetrics);
/**
 * SOURCE OrderMetrics @ squareup/salesreporter/itemization_report.proto at 330:1
 */
export const OrderMetrics = $root.lookupType('squareup.salesreporter.service.OrderMetrics');
fixType(OrderMetrics);
Builder.createAndAttachToType(OrderMetrics);
/**
 * SOURCE TenderDetails @ squareup/salesreporter/itemization_report.proto at 338:1
 */
export const TenderDetails = $root.lookupType('squareup.salesreporter.service.TenderDetails');
fixType(TenderDetails);
Builder.createAndAttachToType(TenderDetails);
/**
 * Request and response for Itemization Available Filters endpoint.
 * This mirrors ItemizationReportRequest scope/period fields and uses presence-based
 * selectors via ItemizationFilterByValue to indicate which facets to return.
 *
 * SOURCE ItemizationSalesAvailableFiltersRequest @ squareup/salesreporter/itemization_report.proto at 347:1
 */
export const ItemizationSalesAvailableFiltersRequest = $root.lookupType('squareup.salesreporter.service.ItemizationSalesAvailableFiltersRequest');
fixType(ItemizationSalesAvailableFiltersRequest, {
  merchantToken: {
    notEmpty: true
  },
  reportingPeriod: {
    required: true
  }
});
Builder.createAndAttachToType(ItemizationSalesAvailableFiltersRequest);
/**
 * SOURCE ItemizationSalesAvailableFiltersResponse @ squareup/salesreporter/itemization_report.proto at 367:1
 */
export const ItemizationSalesAvailableFiltersResponse = $root.lookupType('squareup.salesreporter.service.ItemizationSalesAvailableFiltersResponse');
fixType(ItemizationSalesAvailableFiltersResponse);
Builder.createAndAttachToType(ItemizationSalesAvailableFiltersResponse);
/**
 * SOURCE ItemizationSalesInternalOptions @ squareup/salesreporter/itemization_report.proto at 372:1
 */
export const ItemizationSalesInternalOptions = $root.lookupType('squareup.salesreporter.service.ItemizationSalesInternalOptions');
fixType(ItemizationSalesInternalOptions);
Builder.createAndAttachToType(ItemizationSalesInternalOptions);
/**
 * SOURCE UnsupportedElementBehavior @ squareup/salesreporter/itemization_report.proto at 373:3
 */
ItemizationSalesInternalOptions.UnsupportedElementBehavior = $root.lookupEnum('squareup.salesreporter.service.ItemizationSalesInternalOptions.UnsupportedElementBehavior').values;